import styled from "styled-components";

const SidebarContainer = styled.div`
  font-family: "Do Hyeon", sans-serif;
  ul {
    margin: 0;
    padding-left: 15%;
    li {
      text-align: left;
      list-style: square;
      padding: 3% 0;

      border-bottom: 1px solid rgb(231, 231, 231);
    }
  }
  a {
    text-decoration: none;
    color: #000;
    padding: 0;
    p {
      margin: 0;
      width: 100%;
      text-align: left;
    }
  }
  button {
    color: black;
    background-color: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    font-size: 1rem;
    p {
      margin: 0;
    }
    &:hover {
      color: rgb(1, 165, 188);
    }
  }
  @media only screen and (max-width: 480px) {
    ul {
      padding-left: 10%;
    }
  }
`;

export default SidebarContainer;
